module.exports = __webpack_public_path__ + "img/coins-2.460f273e.png";